import {post, get, patch} from '@/lib/axios';


const notifications = {
  async get_notifications() {
    return get(`/notifications`);
  },
  async get_notifications_settings() {
    return get(`/notifications/settings`);
  },
  async edit_notifications_settings(data) {
    return patch(`/notifications/settings`, data);
  },
  async patch_read(id) {
    return patch(`notifications/${id}/read`);
  },
  async patch_reads(data) {
    return patch(`notifications/read`, data);
  },
};

export {notifications as default};
